import React from "react";
import EventContainer from "./EventContainer";
import bdayImg from "../../assets/bdayImg.png";
import Anniversary from "../../assets/Anniversary.png";
import { Box } from "@mui/system";

const EventWrapper1 = () => {
  return (
    <Box display={"flex"} flexDirection={"column"} maxWidth={"1440px"}>
      <EventContainer
        imgList={[bdayImg, bdayImg]}
        title={"Birthday Party Decoration"}
        description={
          "Come as you are. Be as you are. Breathe in. Breathe out. You are held when you’re with us. With a friendly smile. With a sympathetic ear. In an environment that offers countless opportunities."
        }
        price={15999}
        facilityList={[
          "Suite can accommodate up to 4 people.",
          "Price for 4 adults, per day.",
          "Lunch, Snacks, Dinner & Breakfast Included.",
          "Check-In: 2pm; Check-Out: 10 am.",
          "Pet Friendly.",
          "Decor Price is not included.",
          "Lunch, Snacks, Dinner & Breakfast Included.",
          "Check-In: 2pm; Check-Out: 10 am.",
          "Pet Friendly.",
          "Check-In: 2pm; Check-Out: 10 am.",
        ]}
        SliderPosition={"left"}
      />
      <EventContainer
        imgList={[Anniversary, Anniversary]}
        title={"Anniversary Decoration"}
        description={
          "Come as you are. Be as you are. Breathe in. Breathe out. You are held when you’re with us. With a friendly smile. With a sympathetic ear. In an environment that offers countless opportunities."
        }
        price={15999}
        facilityList={[
          "Suite can accommodate up to 4 people.",
          "Price for 4 adults, per day.",
          "Lunch, Snacks, Dinner & Breakfast Included.",
          "Check-In: 2pm; Check-Out: 10 am.",
          "Pet Friendly.",
          "Decor Price is not included.",
          "Lunch, Snacks, Dinner & Breakfast Included.",
          "Check-In: 2pm; Check-Out: 10 am.",
          "Pet Friendly.",
          "Check-In: 2pm; Check-Out: 10 am.",
        ]}
        SliderPosition={"right"}
      />
      <EventContainer
        imgList={[bdayImg, bdayImg]}
        title={"Candle Light dinner"}
        description={
          "Come as you are. Be as you are. Breathe in. Breathe out. You are held when you’re with us. With a friendly smile. With a sympathetic ear. In an environment that offers countless opportunities."
        }
        price={15999}
        facilityList={[
          "Suite can accommodate up to 4 people.",
          "Price for 4 adults, per day.",
          "Lunch, Snacks, Dinner & Breakfast Included.",
          "Check-In: 2pm; Check-Out: 10 am.",
          "Pet Friendly.",
          "Decor Price is not included.",
          "Lunch, Snacks, Dinner & Breakfast Included.",
          "Check-In: 2pm; Check-Out: 10 am.",
          "Pet Friendly.",
          "Check-In: 2pm; Check-Out: 10 am.",
        ]}
        SliderPosition={"left"}
      />
 
    </Box>
  );
};

export default EventWrapper1;
